//* 화환 단가표 페이지 전용 hook
//* 현재 판매중인 화환(shopItem)의 판매가/원가/상조 수익금 조회 (백엔드 가공 데이터)

import { fetcher, useRecoilQuery } from '@shared/hooks/recoil-query';
import { useAuth } from '@shared/state/hooks/useAuth';

import {
  flowerPriceTableDataAtom,
  flowerPriceTableStatusAtom,
} from './flowerPriceTable.atom';

/** 화환 단가표 URL — bugoBrand 단위 판매중 shopItem (백엔드가 상조 수익금 계산) */
export const flowerPriceTableUrl = (bugoRole: string, bugoBrandId?: string) =>
  `/${bugoRole}/shop-item/price-table?bugoBrand=${bugoBrandId ?? ''}`;

export const useFlowerPriceTableHook = (bugoBrandId?: string) => {
  const { bugoRole } = useAuth();

  useRecoilQuery(
    flowerPriceTableStatusAtom,
    flowerPriceTableDataAtom,
    flowerPriceTableUrl(bugoRole(), bugoBrandId),
    fetcher,
    !bugoBrandId, // bugoBrandId 없으면 비활성
  );
};
